var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowDown = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7436 8.7738C19.8384 8.67907 20.0014 8.67909 20.0962 8.7738C20.1909 8.86854 20.1909 9.0316 20.0962 9.12634L13.5766 15.6469C13.1437 16.0797 12.5722 16.3001 12.0005 16.3002C11.4285 16.3002 10.8563 16.0798 10.4233 15.6469L3.90378 9.12634C3.80904 9.0316 3.80904 8.86854 3.90378 8.7738C3.99852 8.67907 4.16158 8.67907 4.25632 8.7738L10.7768 15.2933C11.4521 15.9685 12.5479 15.9685 13.2231 15.2933L19.7436 8.7738Z",
    fill: "#455CC7",
    stroke: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-down.61c2b441.svg";
export { ForwardRef as ReactComponent };